angular.module('files')
    .service('FilesSimpleUploadService', function (modals) {
        this.open = params => modals.open('app/files/file-upload-simple-modal.html', 'FilesSimpleUploadController', params, {size: 'lg'}, "$ctrl");
        this.openCustom = params => modals.open('app/files/file-upload-simple-modal.html', 'FilesSimpleUploadCustomController', params, {size: 'sm'}, "$ctrl");
    })
    .controller('FilesSimpleUploadController', function ($scope, $rootScope, $uibModalInstance, data, toastr, FileUploader, Folder, $cookies, FileUploaderLocal) {
        let close = result => $uibModalInstance.close(result);
        this.uploader = FileUploaderLocal.create(formDataFn, close);
        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        function formDataFn() {
            return data;
        }
    })
    .controller('FilesSimpleUploadCustomController', function ($scope, $rootScope, $uibModalInstance, data, toastr, FileUploader, Folder, $cookies, FileUploaderCustom) {
        this.$onInit = () => {
            this.uploader = FileUploaderCustom.create(data.url, formDataFn, close, data.settings);
        }

        let close = (result) => $uibModalInstance.close(result);
        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        function formDataFn() {
            return data.formData || {};
        }
    });
